import React from "react";
import FormattedMessage from "@irati/utils/lang";
import { H2 } from "@irati/ui/src/Headings";
import { Label2 } from "@irati/ui/src/Labels";
import { getQuery } from "../../helpers/getOnboardingQuery";
import RequestNewLink from "../../components/UserOnboarding/RequestNewLinkButton";
var MalformedLink = function () {
    var uuid = getQuery().uuid;
    return (React.createElement("div", null,
        React.createElement(H2, { small: true },
            React.createElement(FormattedMessage, { id: "onboarding.malformed.header" })),
        React.createElement(Label2, { block: true, small: true },
            React.createElement(FormattedMessage, { id: "onboarding.malformed.body" }),
            " ",
            uuid && React.createElement(RequestNewLink, { body: "onboarding.malformed.requestNewBody" })),
        React.createElement(Label2, { block: true },
            React.createElement(FormattedMessage, { id: "onboarding.malformed.body2" }))));
};
export default MalformedLink;
